const RegEx = (function () {
  function isHWAddress(mac) {
    // this is for teralytic device's specific mac-like address,
    // if in the future we use real mac addresses, change the 7 to 5
    const macRegex = /^(^([0-9A-Fa-f]{2}[:-]?){7}([0-9A-Fa-f]{2})$)$/;
    return macRegex.test(mac);
  }
  function isUUID(value) {
    const uuidPattern = /^(?:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12})$/;
    return uuidPattern.test(value);
  }

  function isNonEmptyString(value) {
    const pattern = /^\S.*\S$/;
    return pattern.test(value);
  }

  function isEmail(value) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(value);
  }

  function isDomain(value) {
    const domainRegex = /[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+/;
    return domainRegex.test(value);
  }

  function isPositiveNumber(value) {
    const positiveNumberRegex = /^[+]?([.]\d+|\d+([.]\d+)?)$/;
    return positiveNumberRegex.test(value);
  }

  function isFertilizerFormatted(value) {
    const fertilizerRegex = /^\d{1,3}-\d{1,3}-\d{1,3}$/;
    return fertilizerRegex.test(value);
  }

  return {
    isHWAddress,
    isUUID,
    isNonEmptyString,
    isEmail,
    isDomain,
    isPositiveNumber,
    isFertilizerFormatted,
  };
})();

export default RegEx;
